import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import DoDisturbOffIcon from '@mui/icons-material/DoDisturbOff';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import AddCardIcon from '@mui/icons-material/AddCard';
import CheckIcon from '@mui/icons-material/Check';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import PercentIcon from '@mui/icons-material/Percent';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import FmdBadIcon from '@mui/icons-material/FmdBad';
import CampaignIcon from '@mui/icons-material/Campaign';
import AddReactionIcon from '@mui/icons-material/AddReaction';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SellIcon from '@mui/icons-material/Sell';
import ListAltIcon from '@mui/icons-material/ListAlt';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import SearchIcon from '@mui/icons-material/Search';
import { Autocomplete, Box, Card, InputAdornment, Tab, Tabs, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import DiscountRateDynamic from 'src/components/DiscountRateDynamic';
import DiscountedUserDynamic from 'src/components/DiscountedUserDynamic';
import LegalEntityControlDynamic from 'src/components/LegalEntityControlDynamic';
import ServiceRefundDynamic from 'src/components/ServiceRefundDynamic';
import ConvinceTypeDynamic from 'src/components/ConvinceTypeDynamic';
import AbsPriceUploadDynamic from 'src/components/AbsPriceUploadDynamic';
import ConfirmTypeDynamic from 'src/components/ConfirmTypeDynamic';
import SetStatus from 'src/components/SetStatus';
import ExchangeReasonDynamic from 'src/components/ExchangeReasonDynamic';
import ProductBasedExchangeRateDynamic from 'src/components/ProductBasedExchangeRateDynamic';
import OtomaticApprovalDynamic from 'src/components/OtomaticApprovalDynamic';
import ProductQualityControlDynamic from 'src/components/ProductQualityControlDynamic';
import CampaignProductSkuDynamic from 'src/components/CampaignProductSkuDynamic';
import ReceiptManualUpdateDynamic from 'src/components/ReceiptManualUpdateDynamic';
import { ORANGE, DARK, inputSx, listboxProps } from 'src/components/dynamicCatalogStyles';

// Ekranlar gruplanarak listelenir; key adres çubuğunda (?ekran=) kullanılır
const GROUPS = [
  {
    key: 'tanimlar',
    label: 'Tanımlar',
    icon: ListAltIcon,
    screens: [
      { key: 'onay-turu', label: 'Onay Türü ve Detay', icon: CheckIcon, component: ConfirmTypeDynamic },
      { key: 'degisim-nedeni', label: 'Değişim Nedeni ve Detay', icon: SwapHorizontalCircleIcon, component: ExchangeReasonDynamic },
      { key: 'otomatik-onay', label: 'Otomatik Onay Değişim Nedenleri', icon: ThumbUpAltIcon, component: OtomaticApprovalDynamic },
      { key: 'urun-bazli-oran', label: 'Ürün Bazlı Değişim Oranları', icon: PercentIcon, component: ProductBasedExchangeRateDynamic },
      { key: 'kampanya-model', label: 'Kampanya ve Ürün Model Kodu', icon: CampaignIcon, component: CampaignProductSkuDynamic },
      { key: 'urun-kalite', label: 'Ürün Kalite Problemleri', icon: FmdBadIcon, component: ProductQualityControlDynamic },
      { key: 'servis-red', label: 'Servis Red Nedeni', icon: DoDisturbOffIcon, component: ServiceRefundDynamic },
      { key: 'ikna-turleri', label: 'İkna Türleri', icon: AddReactionIcon, component: ConvinceTypeDynamic },
      { key: 'tuzel-kelimeler', label: 'Tüzel-Kişi Kontrol Kelimeler', icon: PersonSearchIcon, component: LegalEntityControlDynamic },
      { key: 'ara-durumlar', label: 'Ara Durumlar', icon: DisplaySettingsIcon, component: SetStatus }
    ]
  },
  {
    key: 'indirim',
    label: 'İndirim',
    icon: SellIcon,
    screens: [
      { key: 'indirim-talep', label: 'İndirim Talep Edilen Kişi', icon: CompareArrowsIcon, component: DiscountedUserDynamic },
      { key: 'kisi-indirim-oran', label: 'Kişi Bazlı İndirim Oranları', icon: LocalOfferIcon, component: DiscountRateDynamic }
    ]
  },
  {
    key: 'islemler',
    label: 'İşlemler',
    icon: BuildCircleIcon,
    screens: [
      { key: 'abs-fiyat', label: 'Abs Fiyat Yükleme', icon: AddCardIcon, component: AbsPriceUploadDynamic },
      { key: 'fis-manuel-guncelleme', label: 'Fiş Manuel Güncelleme', icon: ReceiptLongIcon, component: ReceiptManualUpdateDynamic }
    ]
  }
];

const ALL_SCREENS = GROUPS.flatMap((g) => g.screens.map((s) => ({ ...s, groupKey: g.key, groupLabel: g.label })));
const DEFAULT_SCREEN = ALL_SCREENS[0].key;
const QUERY_KEY = 'ekran';

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: 'Segoe UI',
    width: '100%',
    height: '100%',
    padding: '16px 24px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      padding: '12px'
    }
  },
  card: {
    border: '1px solid #e0e0e0',
    borderRadius: '16px',
    backgroundColor: '#fff',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    overflow: 'hidden'
  },
  // Üst satır: gruplar + ekran arama
  groupBar: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '12px',
    padding: '12px 16px'
  },
  // Gruplar tek bir segment kontrol içinde; seçili grup beyaz kart gibi öne çıkar
  groupList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    padding: '4px',
    borderRadius: '12px',
    backgroundColor: '#f1f3f4',
    border: '1px solid #e8eaed'
  },
  groupButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    height: '34px',
    padding: '0 14px',
    borderRadius: '9px',
    border: 'none',
    backgroundColor: 'transparent',
    color: '#607d8b',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'all 0.15s',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.7)',
      color: DARK
    },
    '& .MuiSvgIcon-root': { fontSize: '18px', color: '#90a4ae', transition: 'color 0.15s' }
  },
  groupButtonActive: {
    backgroundColor: '#fff',
    color: DARK,
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
    '&:hover': { backgroundColor: '#fff' },
    '& .MuiSvgIcon-root': { color: ORANGE }
  },
  groupCount: {
    minWidth: '20px',
    height: '18px',
    padding: '0 6px',
    borderRadius: '9px',
    fontSize: '11px',
    fontWeight: 700,
    lineHeight: '18px',
    textAlign: 'center',
    backgroundColor: '#e0e4e7',
    color: '#607d8b',
    boxSizing: 'border-box'
  },
  groupCountActive: {
    backgroundColor: ORANGE,
    color: '#fff'
  },
  groupSpacer: {
    flex: 1
  },
  // Alt satır: seçili grubun ekranları
  screenBar: {
    backgroundColor: '#f5f5f5',
    borderTop: '1px solid #e0e0e0'
  },
  screenTabs: {
    minHeight: '44px',
    '& .MuiTab-root': {
      minHeight: '44px',
      padding: '6px 14px',
      fontSize: '12px',
      fontWeight: 600,
      textTransform: 'none',
      color: '#607d8b',
      whiteSpace: 'nowrap',
      '& .MuiSvgIcon-root': { fontSize: '18px', marginRight: '6px' }
    },
    '& .MuiTab-root:hover': {
      color: DARK
    },
    '& .MuiTab-root.Mui-selected': {
      color: ORANGE
    }
  }
}));

function Overview() {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const requested = new URLSearchParams(location.search).get(QUERY_KEY);
  const screen = ALL_SCREENS.find((s) => s.key === requested) || ALL_SCREENS.find((s) => s.key === DEFAULT_SCREEN);
  const group = GROUPS.find((g) => g.key === screen.groupKey);
  const ScreenComponent = screen.component;

  const openScreen = (key) => {
    if (key === screen.key) return;
    const params = new URLSearchParams(location.search);
    params.set(QUERY_KEY, key);
    history.replace({ pathname: location.pathname, search: `?${params.toString()}` });
  };

  // Grup değişince o grubun ilk ekranı açılır
  const openGroup = (groupKey) => {
    if (groupKey === group.key) return;
    openScreen(GROUPS.find((g) => g.key === groupKey).screens[0].key);
  };

  return (
    <Box className={classes.root}>
      <Card className={classes.card}>
        <Box className={classes.groupBar}>
          <Box className={classes.groupList}>
            {GROUPS.map((g) => {
              const active = g.key === group.key;
              const Icon = g.icon;
              return (
                <button
                  key={g.key}
                  type="button"
                  className={`${classes.groupButton} ${active ? classes.groupButtonActive : ''}`}
                  onClick={() => openGroup(g.key)}
                >
                  <Icon />
                  {g.label}
                  <span className={`${classes.groupCount} ${active ? classes.groupCountActive : ''}`}>{g.screens.length}</span>
                </button>
              );
            })}
          </Box>
          <Box className={classes.groupSpacer} />
          <Autocomplete
            size="small"
            options={ALL_SCREENS}
            groupBy={(o) => o.groupLabel}
            getOptionLabel={(o) => o.label}
            value={null}
            blurOnSelect
            clearOnBlur
            ListboxProps={listboxProps}
            noOptionsText="Ekran bulunamadı"
            onChange={(e, v) => v && openScreen(v.key)}
            sx={{ width: 260, maxWidth: '100%' }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Ekran ara"
                sx={inputSx}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ fontSize: 18, color: '#90a4ae' }} />
                    </InputAdornment>
                  )
                }}
              />
            )}
          />
        </Box>
        <Box className={classes.screenBar}>
          <Tabs
            value={screen.key}
            onChange={(e, v) => openScreen(v)}
            variant="scrollable"
            scrollButtons="auto"
            className={classes.screenTabs}
            TabIndicatorProps={{ style: { background: ORANGE, height: 3, borderRadius: '3px 3px 0 0' } }}
          >
            {group.screens.map((s) => {
              const Icon = s.icon;
              return <Tab key={s.key} value={s.key} iconPosition="start" icon={<Icon />} label={s.label} />;
            })}
          </Tabs>
        </Box>
      </Card>
      <Box sx={{ pt: 2 }}>
        <ScreenComponent key={screen.key} />
      </Box>
    </Box>
  );
}

export default Overview;
